import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  ApiBuilder,
  AppConfigService,
  EXCEPTION_CATEGORY_ENUM,
  EXCEPTION_FILE_NAMES_ENUM,
  ExceptionTrackingService,
  HttpRequestMethods,
  IExceptionMetadata
} from '../../index';
import {
  DEFAULT_TIMEOUT,
  EndpointKeys,
  IDP_APP
} from './data-models/constants/irop.constants';
import { Irop } from './data-models/irop.interfaces';

@Injectable({
  providedIn: 'root'
})
export class IropService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService
  ) {}

  errorHandler = this.handleError.bind(this);

  getContent = (): Observable<Irop> =>
    new ApiBuilder<undefined, Irop>(this.http, this.appConfig)
      .app(IDP_APP)
      .endpointKey(EndpointKeys['IROP_GLOBAL_URL'])
      .method(HttpRequestMethods['GET'])
      .timeOut(DEFAULT_TIMEOUT)
      .errorHandler(this.errorHandler)
      .create();

  handleError(httpErrorResponse: HttpErrorResponse): Observable<never> {
    this.trackExceptions(httpErrorResponse);
    return throwError(httpErrorResponse);
  }

  trackExceptions(httpErrorResponse: HttpErrorResponse) {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES_ENUM.IROP_SERVICE,
      methodName: '_handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: httpErrorResponse.error
    };
    this.exceptionTrackingService.track(
      `[${IDP_APP}]: ${httpErrorResponse.status} : ${httpErrorResponse.url}`,
      exceptionMetadata
    );
  }
}
